import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { Scale, ScaleCode } from './scales.interface';

interface ScaleRangeRouteResponse {
    rangeCode: string;
    rangeLabel: string;
    rangeColor: string;
    rangeMaxValue: number;
}

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreScalesProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    fetchScaleRanges$(): Observable<Scale[]> {
        type RouteResponse = {
            scaleCode: string;
            scaleCategory: string;
            scaleRangeValues: ScaleRangeRouteResponse[];
        }[];

        return this._rosaCoreApiService.get<RouteResponse>(`${CoreApiVersionPath.V4}scales`).pipe(
            map(scales => {
                return scales.map(scale => {
                    return {
                        scaleCode: scale.scaleCode as ScaleCode,
                        scaleCategory: scale.scaleCategory,
                        scaleRanges: scale.scaleRangeValues.map(scaleRange => {
                            return {
                                code: scaleRange.rangeCode,
                                label: scaleRange.rangeLabel,
                                color: scaleRange.rangeColor,
                                maxValue: scaleRange.rangeMaxValue === null ? Infinity : scaleRange.rangeMaxValue
                            };
                        })
                    };
                });
            })
        );
    }
}
